import AccountDowngradeModal from "components/Common/AccountDowngradeModal"
import AccountUpgradeModal from "components/Common/AccountUpgradeModal"
import AddonPackagesDropdown from "components/Common/AddonPackagesDropdown"
import CardPricing from "components/Common/card-pricing"
import {
  IsQCLaborUser,
  IsQCModuleEnabled,
  IsRepairModuleEnabled,
  IsPartnerCockpitModuleEnabled,
  IsCPSModuleEnabled,
  IsTraderCompany,
} from "helpers/misc_helpers"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { Alert, Col, Row } from "reactstrap"

const PricingSettingsTab = ({ user }) => {
  const isTrader = IsTraderCompany()
  const [anual, setAnual] = useState(true)
  const [upgradeModal, setUpgradeModal] = useState(false)
  const [downgradeModal, setDowngradeModal] = useState(false)
  const [qcModuleEnabled, setQCModuleEnabled] = useState(false)
  const [repairModuleEnabled, setRepairModuleEnabled] = useState(false)
  const [partnerCockpitModuleEnabled, setPartnerCockpitModuleEnabled] =
    useState(false)
  const [cpsModuleEnabled, setCPSModuleEnabled] = useState(false)

  const pricings = [
    {
      id: 1,
      title: "Free Package",
      description: "Pricing plan for free features",
      description2: "Access to our part search and watchlist.",
      price: anual ? "0" : "0",
      duration: anual ? "per year" : "per half year",
      link: _ => setDowngradeModal(true),
      btnText: user?.accountType == "Standard" ? "Current Plan" : "Downgrade",
      disabled: user?.accountType == "Standard",
      userType: "Free",
      features: [
        { title: "Limited part search", icon: "bx bx-check", color: "primary" },
        {
          title: "Upload your Excess material list and Watchlist",
          icon: "bx bx-check",
          color: "primary",
        },
        { title: "Single User Account", icon: "bx bx-check", color: "primary" },
        { title: "Buy / Sell parts", icon: "bx bx-x", color: "danger" },
      ],
    },
    {
      id: 2,
      title: "Basic Package",
      description: "Pricing plan for basic features",
      description2:
        "Unlimited access to all basic features and no user restrictions.",
      price: anual ? "500" : "250",
      duration: anual ? "per year" : "per half year",
      link: _ => setUpgradeModal(true),
      btnText: user?.accountType == "Premium" ? "Current Plan" : "Upgrade Plan",
      disabled: user?.accountType == "Premium",
      userType: "Standard",
      features: [
        {
          title: "Unlimited part search",
          icon: "bx bx-check",
          color: "primary",
        },
        { title: "Buy / Sell parts", icon: "bx bx-check", color: "primary" },
        { title: "Unlimited user", icon: "bx bx-check", color: "primary" },
        { title: "API interface", icon: "bx bx-x", color: "danger" },
      ],
    },
  ]

  const addons = [
    {
      id: 4,
      title: "Add-on QC-Module",
      description: "Standardized QC Test workflow",
      description2: "Ensures products meet set standards.",
      icon: "",
      price: anual ? "500" : "250",
      duration: anual ? "per year" : "per half year",
      disabled: qcModuleEnabled,
      btnText: qcModuleEnabled ? "active" : "Request QC-Module",
      link: _ =>
        window.open(
          "https://chipsconnect.com/chipsconnect-qc-registration",
          "_blank"
        ),
      features: [
        {
          title: "Standardized QC Test workflow",
          icon: "bx bx-check",
          color: "primary",
        },
        {
          title: "One-stop request management",
          icon: "bx bx-check",
          color: "primary",
        },
        {
          title: "Peer-to-peer contact Buyer-Seller-QC lab",
          icon: "bx bx-check",
          color: "primary",
        },
        { title: "Automatic Updates", icon: "bx bx-check", color: "primary" },
      ],
    },
    {
      id: 5,
      title: "Add-on Repair-Module",
      description: "Comprehensive repair management system",
      description2:
        "Streamline your repair processes and track repair requests.",
      icon: "",
      price: anual ? "500" : "250",
      duration: anual ? "per year" : "per half year",
      disabled: repairModuleEnabled,
      btnText: repairModuleEnabled ? "active" : "Request Repair-Module",
      link: _ =>
        window.open(
          "https://chipsconnect.com/chipsconnect-repair-module-registration",
          "_blank"
        ),
      features: [
        {
          title: "Repair request management",
          icon: "bx bx-check",
          color: "primary",
        },
        {
          title: "Detailed repair type selection",
          icon: "bx bx-check",
          color: "primary",
        },
        {
          title: "Repair status tracking",
          icon: "bx bx-check",
          color: "primary",
        },
        { title: "Automatic Updates", icon: "bx bx-check", color: "primary" },
      ],
    },
    {
      id: 6,
      title: "Add-on Partner Cockpit",
      description: "Collaborative partner management platform",
      description2: "Manage your business relationships and collaborations.",
      icon: "",
      price: anual ? "2000" : "1000",
      duration: anual ? "per year" : "per half year",
      disabled: partnerCockpitModuleEnabled,
      btnText: partnerCockpitModuleEnabled
        ? "active"
        : "Request Partner Cockpit",
      link: _ =>
        window.open(
          "https://chipsconnect.com/chipsconnect-partner-cockpit-registration/",
          "_blank"
        ),
      features: [
        {
          title: "Partner relationship management",
          icon: "bx bx-check",
          color: "primary",
        },
        {
          title: "Collaborative workspace",
          icon: "bx bx-check",
          color: "primary",
        },
        {
          title: "Document sharing and management",
          icon: "bx bx-check",
          color: "primary",
        },
        { title: "Automatic Updates", icon: "bx bx-check", color: "primary" },
      ],
    },
    {
      id: 7,
      title: "Add-on CPS-Module",
      description: "PCB Programming and Sleeving services",
      description2:
        "Access professional PCB programming and sleeving services through certified CPS laboratories.",
      icon: "",
      price: anual ? "500" : "250",
      duration: anual ? "per year" : "per half year",
      disabled: cpsModuleEnabled,
      btnText: cpsModuleEnabled ? "active" : "Request CPS-Module",
      link: _ =>
        window.open(
          "https://chipsconnect.com/chipsconnect-cps-registration/",
          "_blank"
        ),
      features: [
        {
          title: "Access to certified CPS laboratories",
          icon: "bx bx-check",
          color: "primary",
        },
        {
          title: "PCB Programming services",
          icon: "bx bx-check",
          color: "primary",
        },
        {
          title: "PCB Sleeving services",
          icon: "bx bx-check",
          color: "primary",
        },
        {
          title: "Real-time production tracking",
          icon: "bx bx-check",
          color: "primary",
        },
      ],
    },
    {
      id: 3,
      title: "Add-on API Package",
      description: "Pricing plan to get the API",
      description2: "No one-time costs for API implementation.",
      icon: "",
      price: anual ? "300" : "150",
      duration: anual ? "per year" : "per half year",
      disabled: false,
      btnText: "Request API",
      link: _ =>
        window.open(
          "https://chipsconnect.com/chipsconnect-api-registration/",
          "_blank"
        ),
      features: [
        { title: "API interface", icon: "bx bx-check", color: "primary" },
        { title: "API maintenance", icon: "bx bx-check", color: "primary" },
        { title: "Automatic updates", icon: "bx bx-check", color: "primary" },
        { title: "Basic package", icon: "bx bx-x", color: "danger" },
      ],
    },
  ]

  // ── Rollenbasierte Aufteilung ──────────────────────────────────────────────
  // OEM/EMS: Hauptlinie Free / Basic / Partner Cockpit; Rest im Add-on-Pulldown.
  const partnerCockpitCard = addons.find(a => a.id === 6)
  const oemMainLine = [...pricings, partnerCockpitCard].filter(Boolean)
  const oemAddons = addons.filter(a => a.id !== 6) // QC, Repair, CPS, API

  // Trader: keine Preise, individuelle Konditionen. Free/Basic/API/QC im Pulldown.
  const stripPrice = card =>
    card ? { ...card, price: null, link: null, disabled: false, btnText: undefined } : null
  const traderFreeCard = {
    id: "trader-free",
    title: "Free Package",
    description: " ",
    description2: "Base access for traders — pricing agreed individually.",
    price: null,
    features: [
      { title: "Anonymous display of your searches", icon: "bx bx-check", color: "primary" },
      { title: "Upload parts / excess list", icon: "bx bx-check", color: "primary" },
      { title: "Single User Account", icon: "bx bx-check", color: "primary" },
      { title: "Buy / Sell parts", icon: "bx bx-x", color: "danger" },
    ],
  }
  const traderPackages = [
    traderFreeCard,
    stripPrice(pricings.find(p => p.id === 2)), // Basic
    stripPrice(addons.find(a => a.id === 3)), // API
    stripPrice(addons.find(a => a.id === 4)), // QC
  ].filter(Boolean)

  useEffect(() => {
    IsQCModuleEnabled().then(result => setQCModuleEnabled(result))
    IsRepairModuleEnabled().then(result => setRepairModuleEnabled(result))
    IsPartnerCockpitModuleEnabled().then(result =>
      setPartnerCockpitModuleEnabled(result)
    )
    IsCPSModuleEnabled().then(result => setCPSModuleEnabled(result))
  }, [])

  return (
    <div>
      {IsQCLaborUser() ? (
        <h3 className="m-3">Not available for QC-Labors</h3>
      ) : (
        <>
          <h5 className="mb-4">Pricing</h5>
          <Row>
            <Col lg="8" className="">
              <p>
                Here are our Packages which are currently available. <br />
                {user?.lastInvoice && (
                  <b className="me-2">
                    Next invoice:{" "}
                    {moment(user.lastInvoice)
                      .add(
                        user.billingPeriod == "half-yearly" ? 0.5 : 1,
                        "year"
                      )
                      .format("DD.MM.YYYY")}
                  </b>
                )}
                {user?.trialUntil && (
                  <b className="me-2">
                    Trial until:{" "}
                    {moment(user.company.trialUntil).format("DD.MM.YYYY")}
                  </b>
                )}
              </p>
            </Col>
          </Row>
          {isTrader ? (
            <>
              <Alert color="info">
                <i className="bx bx-info-circle me-1" />
                As a trader, your conditions are agreed individually after
                registration and an initial call with chipsconnect. No package
                prices are shown here.
              </Alert>
              <AddonPackagesDropdown
                addons={traderPackages}
                title="Packages"
                defaultOpen={true}
              />
            </>
          ) : (
            <>
              <Row className="justify-content-start mt-4 mb-4">
                {oemMainLine.map((pricing, key) => (
                  <CardPricing pricing={pricing} key={"_pricing_" + key} />
                ))}
              </Row>

              <AddonPackagesDropdown addons={oemAddons} />
            </>
          )}

          <AccountUpgradeModal
            onCancel={_ => setUpgradeModal(false)}
            onSuccess={_ => setUpgradeModal(false)}
            show={upgradeModal}
          />

          <AccountDowngradeModal
            onSuccess={_ => setDowngradeModal(false)}
            onCancel={_ => setUpgradeModal(false)}
            show={downgradeModal}
          />
        </>
      )}
    </div>
  )
}

export default PricingSettingsTab
